export default {
  data () {
    return {
      modal: false
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.$nextTick(() => this.$emit('closeModal'))
      }
    }
  },
  methods: {
    close () { this.modal = false }
  },
  mounted () {
    this.modal = true
  }
}



// WEBPACK FOOTER //
// ./src/mixins/autoOpenModal.js